// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"zp-z","selected":"Ap-z"};